import { Button } from '../../../../../components/Button/Button'

export interface LinkNewEmailVerificationSentBodyProps {
  email: string
  onHide: () => void
}

export const LinkNewEmailVerificationSentBody = ({ email, onHide }: LinkNewEmailVerificationSentBodyProps) => {
  return (
    <>
      <div className='text-center'>
        <p>
          <i className='bi bi-check-circle text-success fs-1' />
        </p>
        <p>
          Verification link sent to
          <br />
          <strong>{email}</strong>
          <br />
          Check your inbox to verify it.
        </p>
      </div>

      <div className='d-flex w-100 justify-content-center pt-4'>
        <Button variant='primary' className='w-100' onClick={onHide}>
          Done
        </Button>
      </div>
    </>
  )
}
